/**
 * @generated SignedSource<<4fdd5e5844aa814bd7995eb8cbef0e6a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedCondensedSidebarButtons_itemSearch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SaveSearchButton_itemSearch" | "SharedSaveSearchContext_itemSearch">;
  readonly " $fragmentType": "PdpSharedCondensedSidebarButtons_itemSearch";
};
export type PdpSharedCondensedSidebarButtons_itemSearch$key = {
  readonly " $data"?: PdpSharedCondensedSidebarButtons_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedCondensedSidebarButtons_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedCondensedSidebarButtons_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SaveSearchButton_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedSaveSearchContext_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "2f489396c908956abb1605567474012f";

export default node;
